import { RequestService } from '../../../../../common/services/RequestService';
import { GET_FILTER_ORDERS } from '../constants';
import {
  dataAdjustmentFiltersRequest,
  dataAdjustmentResponse,
} from './dataAdjustmentResponse';

export const getFilterOrdersRequest = async (profileId, filters) => {
  const response = await RequestService.get(
    GET_FILTER_ORDERS.replace('{profile_id}', profileId),
    {
      params: dataAdjustmentFiltersRequest(filters),
    }
  );
  return (
    response.data &&
    Array.isArray(response.data) &&
    response.data.map(document => dataAdjustmentResponse(document))
  );
};
